<template>
  <v-container class="cta-section-wrapper" fluid>
    <v-row>
      <v-col class="col-12 col-md-6 pa-md-0" offset-md="1">
        <h2 v-html="data.title"></h2>
        <h5 v-html="data.subtitle"></h5>
      </v-col>
      <v-col class="col-12 col-md-4 pa-md-0 right-side" offset-md="1">
        <a
          class="button"
          :href="data.button.url"
          :target="data.button.external_url === true ? '_blank' : '_self'"
          >{{ data.button.text }}</a
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CtaSection',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.cta-section-wrapper
  background: #003036 url("~@/assets/images/homepage/cta-section-image03.png") no-repeat right center
  display: flex
  justify-content: center
  align-items: center
  border-radius: 8px
  .row
    min-height: 296px
  .row .col:not(.right-side)
    display: flex
    justify-content: center
    align-items: flex-start
    flex-flow: column
  h2
    font-family: 'metropolissemi_bold'
    font-style: normal
    font-weight: 600
    font-size: 48px
    line-height: 64px
    text-align: left
    color: #FFFFFF
    margin-bottom: 20px
  h5
    font-family: 'metropolisregular'
    font-style: normal
    font-weight: 400
    font-size: 16px
    line-height: 1
    text-align: left
    color: #FFFFFF
    ::v-deep
      span
        font-family: 'metropolisbold'
        font-weight: 700
  .right-side
    position: relative
    .button
      background: #26D07C
      position: absolute
      bottom: 10%
      right: 20%
      display: inline-block
      font-family: 'metropolisbold'
      font-style: normal
      font-weight: 700
      font-size: 16px
      line-height: 1
      text-transform: uppercase
      color: #003036
      align-items: center
      padding: 12px 48px
      border-radius: 20px
      outline: none
      text-decoration: none
      transition: all 300ms ease-in-out
      &:hover
        background: #003036
        color: #ffffff
        transition: all 300ms ease-in-out
  @media screen and (max-width: 959px)
    background-position: bottom right
    background-size: 100%
    .row
      min-height: 540px
    .row .col:not(.right-side)
      justify-content: flex-start
      padding-top: 44px
      padding-left: 16px
      padding-right: 16px
    h2,
    h5
      text-align: center
    h2
      font-size: 32px
      line-height: 48px
    .right-side
      .button
        width: 80%
        bottom: 50%
        right: 50%
        text-align: center
        transform: translate(50%, 50%)
</style>
